/**
 * Bag steppers — CLAUDE.md §2, §6.
 *
 * The bag updates as the stepper is pressed, like every other counter on the
 * site. Nothing eases; counts flicker via steps(1, end) and the totals cut.
 */
(function () {
  var root = document.querySelector('[data-bag]');
  if (!root) return;

  function pad(n) {
    return ('0' + n).slice(-2);
  }

  function flick(el) {
    if (!el) return;
    el.classList.remove('fl');
    void el.offsetWidth;
    el.classList.add('fl');
    // Off again once it has run, or an interrupted animation leaves the
    // element holding a phosphor bloom it never comes out of.
    setTimeout(function () { el.classList.remove('fl'); }, 760);
  }

  function money(cents) {
    var formatter = new Intl.NumberFormat(root.dataset.locale || 'en-GB', {
      style: 'currency', currency: root.dataset.currency || 'GBP'
    });
    return formatter.format(cents / 100);
  }

  function busy(state) {
    root.querySelectorAll('[data-line-step]').forEach(function (button) {
      button.disabled = state;
    });
  }

  function apply(cart) {
    var manifestCount = document.querySelector('[data-manifest-count]');
    if (manifestCount) {
      manifestCount.textContent = pad(cart.item_count);
      flick(manifestCount);
      var control = manifestCount.closest('.strip__bag');
      if (control) control.toggleAttribute('data-filled', cart.item_count > 0);
    }

    // The bag's own refresh, so a quantity change reads as the machine
    // recalculating rather than a number quietly becoming different.
    var totals = root.querySelector('.manifest__total');
    if (totals) {
      totals.classList.remove('swept');
      void totals.offsetWidth;
      totals.classList.add('swept');
      setTimeout(function () { totals.classList.remove('swept'); }, 600);
    }

    var total = root.querySelector('[data-bag-total]');
    if (total) {
      total.textContent = money(cart.total_price);
      flick(total);
    }

    var status = root.querySelector('[data-bag-status]');
    if (status) {
      status.textContent = cart.item_count > 0 ? pad(cart.item_count) + ' units' : 'Empty';
    }

    // A line that reached zero is gone, and the totals have moved. Reloading is
    // the honest way to show that rather than patching the DOM into agreement.
    if (cart.item_count === 0 || cart.items.length !== root.querySelectorAll('.manifest__line').length) {
      window.location.reload();
    }
  }

  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-line-step]');
    if (!button) return;

    var line = button.closest('[data-line]');
    var display = line.querySelector('[data-line-count]');
    var next = parseInt(display.textContent, 10) + parseInt(button.dataset.lineStep, 10);
    if (next < 0) return;

    busy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: next })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('change failed');
        return response.json();
      })
      .then(function (cart) {
        display.textContent = next;
        flick(display);
        var lineTotal = line.closest('.manifest__line').querySelector('[data-line-total]');
        var updated = cart.items[parseInt(line.dataset.line, 10) - 1];
        if (lineTotal && updated) {
          lineTotal.textContent = money(updated.final_line_price);
          flick(lineTotal);
        }
        apply(cart);
      })
      .catch(function () {
        window.location.reload();
      })
      .then(function () {
        busy(false);
      });
  });
})();
